<template>
    <div class="companywrap" :style="{minHeight:bottomHeight}">
        <div class="bustop">
            <div class="busleft">
                <p :class="[current == index ? 'active' : '']" v-for="(item, index) in leftNav" :key="index" @click="changeNav(index)">
                    <span v-if="langSet == 'zh'">{{item.ch}}</span>
                    <span v-if="langSet == 'en'">{{item.en}}</span>
                </p>
            </div>
            <div class="busright">
                <p @click="releaseDemand">{{$t('exhibitor.release')}}</p>
                <p class="Inbox" @click="inbox"><i v-if="userInfo.isread > 0"></i>{{$t('exhibitor.Inbox')}}</p>
            </div>
        </div>
        <div class="waterfall-wrap" v-if="list.length > 0">
            <div class="cell-item-wrap">
                <div class="cell-item" v-for="item in list" :key="item.id" @click="details(item.id)">
                    <div class="cell-list">
                        <div class="cell-top">
                            <img :src="$imgUrl + item.avatar" alt=""  /> 
                            <div>
                                <p class="cell-name">{{item.name}}
                                    <span v-if="langSet == 'zh' || item.en_dutiesName.length == 0">{{item.dutiesName}}</span>
                                    <span v-if="langSet == 'en' && item.en_dutiesName.length > 0">{{item.en_dutiesName}}</span>
                                </p>
                                <p class="cell-type">{{item.company}}</p>
                            </div>
                        </div>
                        <div class="cell-con">
                            <p class="cell-title">{{$t('exhibitor.description')}}</p>
                            <p v-if="langSet == 'zh' || item.en_description.length == 0" class="cell-text">{{item.description}}</p>
                            <p v-if="langSet == 'en' && item.en_description.length > 0" class="cell-text">{{item.en_description}}</p>
                            <div class="cell-imglist">
                                <img v-for="(_item, _index) in item.imgs" :key="_index" :src="$imgUrl + _item.url" alt="">
                            </div>
                        </div>
                        <div class="cell-sub">
                            <span>{{item.inputtime}}</span>
                            <span>{{$t('exhibitor.answer')}}{{item.replynum}}{{$t('exhibitor.people')}}</span>
                        </div>
                        <div class="tips" v-if="item.status == 2">{{$t('exhibitor.statusOne')}}</div>
                        <div class="tips blue" v-if="item.status == 1">{{$t('exhibitor.statusTwo')}}</div>
                    </div>
                </div>
            </div>
        </div>
        <el-pagination
            v-if="list.length > 0"
            background
            :page-size = pagesize
            layout="total,prev, pager, next"
            :total="total">
        </el-pagination>
        <div class="nodata" v-if="list.length == 0" style="padding-top:200px;">
            <img v-if="langSet == 'zh'" src="../../../assets/nodata.png" alt="">
            <img v-else src="../../../assets/nodata01.png" alt="">
        </div>
    </div>
</template>

<script>
import { getNeedList, getUser } from "@/api/api";
export default {
    data() {
        return {
            leftNav:[
                {
                    ch: '全部',
                    en: 'All'
                },
                {
                    ch: '供应类',
                    en: 'Exhibitor'
                },
                {
                    ch: '采购类',
                    en: 'Buyer'
                }
            ],
            current: 0,
            col: 2,
            list: [],
            page:1,
            total: 0,
            pagesize:20,
            bottomHeight:'',
            langSet: '',
            userInfo:{}
        }
    },
    created() {
    },
    mounted() {
        this.langSet = localStorage.getItem('languageSet') || 'zh';
        this.memberid = localStorage.getItem('memberid');
        this.uuid = localStorage.getItem('uuid');
        this.getData();
        this.getList(0);
        this.setBottomHeight();
    },
    computed:{

    },
    methods: {
        setBottomHeight(){
            this.bottomHeight = window.innerHeight  - 250 + 'px';
        },
        inbox(){
            this.$router.push({path: '/inbox'});
        },
        changeNav(index){
            this.current = index;
            this.getList(index)
        },
        releaseDemand(){
            this.$emit('show-demand', true);
        },
        getData(){
            let data = this.$qs.stringify({
                memberid: this.memberid,
                uuid:this.uuid
            })
            getUser(data).then(res=>{
                //console.log(res.data.rst)
                if(res.data.errno == 0){
                    this.userInfo = res.data.rst;
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        getList(status) {
            let data = this.$qs.stringify({
                status,
                type: 2,
                memberid: this.memberid,
                page: this.page,
                personal:1,
            })
            getNeedList(data).then(res=>{
                //console.log(res)
                if(res.data.errno == 0){
                    this.list = res.data.rst;
                    this.total = Number(res.data.errmsg);
                }
            }).catch(err=>{
                console.log(err)
            })
        },
        changePage(val){
            if(!this.$store.state.isLogin){
                this.$router.push({path: '/login'});
                return false;
            }
            this.page = val;
            this.getList(0)
        },
        details(id){
            if(!this.$store.state.isLogin){
                this.$router.push({path: '/login'});
                return false;
            }
            this.$emit('show-details', id);
        }
    }
}
</script>

<style lang="scss">
.bustop{
    display: flex;justify-content: space-between;margin-bottom: 20px;
    .busleft{
        display: flex;
        p{width: auto;text-align: center;line-height: 45px;margin-right: 60px;font-size:20px;color: #000;font-weight: 400;cursor: pointer;padding: 0 10px;}
        p.active{color: #CAC28A;font-weight: 600;font-size:24px;border-bottom: 2px solid #CAC28A;}
        p:last-child{margin-right: 0;}
    }
    .busright{ 
        display: flex;
        p{width:133px;height:38px;background:#CAC28A;text-align: center;line-height: 40px;color: #fff;font-size: 20px;cursor: pointer;border:2px solid #CAC28A;}
        p.Inbox{
            background:#fff;color: #4574ED;border-color:#4574ED;margin-left: 11px;position: relative;
            i{width:10px;height:10px;background:rgba(255,0,0,1);border-radius: 50%;position: absolute;top: 4px;right: 28px;}
        }
    }
}
// .bustop > div{flex: 1;}
.waterfall-wrap{
    padding-bottom: 97px;min-height: 500px;
    .cell-item-wrap{
        column-count: 2;column-gap: 10;margin-bottom: 25px;
        .cell-item{
            margin-bottom: 20px;cursor: pointer;position: relative;width: 100%;break-inside:avoid;
            .cell-list{
                width: 98%;background:rgba(237,237,237,1);box-shadow:0px 2px 4px 0px rgba(221,221,221,1);border-radius:6px;border:1px solid rgba(221,221,221,1);box-sizing: border-box;padding: 13px 10px 14px;
                .cell-top{
                    display: flex;margin-bottom: 14px;align-items: center;
                    img{width:52px;height:52px;border-radius: 50%;margin-right: 12px;}
                    .cell-name{
                        font-size: 16px;color: #000;line-height: 22px;
                        span{font-size: 12px;color: #666;margin-left: 10px;}
                    }
                    .cell-type{font-size: 12px;color: #666;line-height: 17px;margin-top: 2px;}
                }
                .cell-con{
                    .cell-title{font-size:14px;color: #000;line-height: 20px;}
                    .cell-text{font-size:14px;color: #666;line-height: 20px;}
                }
                .cell-sub{
                    font-size:12px;color: #666;padding-top: 20px;
                    span{margin-right: 10px;}
                }
            }
            .tips{position: absolute;top: 0;right: 0;width: 72px;height: 28px;text-align: center;background: url(../../../assets/bsbg.png) no-repeat;background-size: 100% 100%;color: #fff;font-size:14px;line-height: 28px;}
            .tips.blue{background: url(../../../assets/bsbg01.png) no-repeat;background-size: 100% 100%;}
            .cell-imglist{
                display: flex;padding-top: 8px;
                img{width:72px;height:72px;margin-right: 10px;}
            }
        }
    }
}
 
@media only screen and (max-width: 1020px){
  .busright{
      p{width: 100px;}
      p.Inbox i{right: 13px;}
  } 
  .bustop .busleft p{margin-right: 25px;}
}
@media only screen and (max-width: 767px){
    .bustop{
        flex-wrap: wrap;align-items: center;justify-content: space-between;
        .busleft{
            p{margin-right: 0;font-size: 14px;line-height: 0.4rem;padding:0 0.05rem;}
            p.active{font-size: 14px;}
        } 
        .busright {
            display: flex;
            p{
                width: 0.96rem;
                font-size: 12px;
                height: 0.44rem;
                line-height: 0.44rem;
            }
            p.Inbox{
                margin-left: 0.1rem;
                i{
                    width: 0.06rem;
                    height: 0.06rem;
                    right: 3px;
                }
            }
        }
    }
    .companywrap .el-pagination{height: 0.52rem;padding:0.05rem;}
    .companywrap .el-pagination button, .companywrap .el-pagination span:not([class*=suffix]){height: 0.36rem;line-height: 0.36rem;font-size: 12px;}
    .companywrap .el-pagination.is-background .el-pager li {width: 0.41rem;height: 0.41rem;line-height: 0.41rem;}
    .companywrap .el-pager li{font-size: 12px;}
    .el-pager, .el-pager li{vertical-align: middle;}
    .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{min-width: auto;}
    .companywrap .el-pagination .btn-next .el-icon, .companywrap .el-pagination .btn-prev .el-icon{font-size: 18px;line-height: 0.44rem;}
    .nodata{width: 70%;padding-top: 2rem;}
    .waterfall-wrap{
        .cell-item-wrap{
            column-count: 1;column-gap: 0;
            .cell-item{
                margin-left: 0;width: 100%;
                .cell-list{
                    width: 98%;
                    padding: 0.2rem;
                    .cell-top{
                        img{
                            width: 0.78rem;
                            height: 0.78rem;
                            margin-right: 0.24rem;
                        }
                        .cell-name{
                            width: 100%;
                            font-size: 15px;
                            padding-right: 0.7rem;
                            box-sizing: border-box;
                            span{
                                margin-left: 0.1rem;
                            }
                        }
                    }
                    .cell-con {
                        .cell-title{font-size: 13px;}
                        .cell-text{font-size: 12px;}
                    }
                    .cell-sub{padding-top: 0.2rem;}
                }
                .tips{
                    top: 0.06rem;
                    width: 1.08rem;
                    height: 0.4rem;
                    font-size: 12px;
                    line-height: 0.4rem;
                }
            }
        }
    }
}
</style>